module.exports = __webpack_public_path__ + "static/media/m_sf_4.164e883f.png";